<template>
  <div id="Processing">Processing View</div>
</template>

<script>
export default {
    name: 'Processing',
    components: {},
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {}
};
</script>
